import { render, staticRenderFns } from "./AddFinanceMarket.vue?vue&type=template&id=6203632d&scoped=true&"
import script from "./AddFinanceMarket.vue?vue&type=script&lang=js&"
export * from "./AddFinanceMarket.vue?vue&type=script&lang=js&"
import style0 from "./AddFinanceMarket.vue?vue&type=style&index=0&id=6203632d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6203632d",
  null
  
)

export default component.exports